import { TabState } from "../context/TabContext";
import { Action, ActionTypes } from "../hooks/useTabContextProvider";

export const tabReducer = (state: TabState, action: ActionTypes) => {
  switch (action.type) {
    case Action.ChangeActiveTab:
      return { ...state, activeTab: action.id };
    default:
      return state;
  }
};
